import View             from '@widesk-ui/components/View';
import React            from 'react';
import useDesignTokens  from '@/hooks/useDesignTokens';

/**
 * Entoure `children` d'une bordure pointillée bleue (`tokens.color.primary`) quand `mixed` est vrai
 * — habillage "valeurs différentes entre les formes sélectionnées", même convention que
 * `MixedSelect`/`TriStateSwitch`, factorisée ici pour être réutilisable par n'importe quel champ
 * (ex. `InputOk`) plutôt que réimplémentée à chaque fois.
 */
export default function MixedBorder({ mixed, br = 8, children }: {
	mixed?: boolean;
	br?: number;
	children: React.ReactNode;
}) {
	const tokens = useDesignTokens();

	if (!mixed) return <>{children}</>;

	return (
		<View br={br} p={2} style={{ border: `1.5px dashed ${tokens.color.primary}` }}>
			{children}
		</View>
	);
}
